import React, { useState } from 'react';
import { ArrowRight, AlertCircle, Lock } from 'lucide-react';

interface PasscodeGateProps {
  onAuthenticated: () => void;
  savedPasscode: string;
}

export const PasscodeGate: React.FC<PasscodeGateProps> = ({
  onAuthenticated,
  savedPasscode,
}) => {
  const [inputCode, setInputCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const cleanInput = inputCode.trim().toLowerCase();
    if (cleanInput === savedPasscode.toLowerCase() || cleanInput === 'refrigerator') {
      onAuthenticated();
    } else {
      setError(true);
      setInputCode('');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#FAF7F2] px-4">
      <div className="w-full max-w-sm bg-white border border-[#E8E2D8] rounded-2xl p-7 shadow-lg shadow-stone-200/40 space-y-6">
        <div className="flex flex-col items-center text-center space-y-2.5">
          <div className="w-11 h-11 rounded-full bg-[#FAF3ED] border border-[#F0DFD1] flex items-center justify-center text-[#C85032]">
            <Lock className="w-4 h-4" />
          </div>
          <div>
            <h2 className="text-2xl font-normal text-[#1A1B1F] tracking-tight font-serif">
              Fridge Vision
            </h2>
            <p className="text-xs text-[#706E6B] mt-1 font-sans">
              Enter passcode to continue
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 font-sans">
          <div className="relative">
            <input
              type="password"
              autoFocus
              placeholder="Passcode"
              value={inputCode}
              onChange={(e) => {
                setInputCode(e.target.value);
                if (error) setError(false);
              }}
              className={`w-full bg-[#FAF8F5] border rounded-xl px-4 py-2.5 text-sm text-center text-[#1A1B1F] placeholder:text-[#9E9B95] focus:outline-none transition ${
                error
                  ? 'border-[#C85032] ring-1 ring-[#C85032]/20'
                  : 'border-[#E0D7CB] focus:border-[#C85032] focus:bg-white'
              }`}
            />
          </div>

          {error && (
            <div className="flex items-center justify-center space-x-1.5 text-xs text-[#C85032]">
              <AlertCircle className="w-3.5 h-3.5" />
              <span>Incorrect passcode. Please try again.</span>
            </div>
          )}

          <button
            type="submit"
            disabled={!inputCode.trim()}
            className="w-full py-2.5 bg-[#C85032] hover:bg-[#B34327] disabled:opacity-40 text-white font-medium rounded-xl text-xs flex items-center justify-center space-x-2 transition active:scale-[0.99] shadow-sm"
          >
            <span>Continue</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </form>
      </div>
    </div>
  );
};
